import React, { ForwardedRef } from 'react';
import { SpaceProps } from 'styled-system';
import SkapaPill from '@ingka/pill';
import '@ingka/pill/dist/style.css';

type Props = React.ComponentProps<typeof SkapaPill> & SpaceProps;

const Pill = React.forwardRef((props: Props, ref: ForwardedRef<HTMLButtonElement>) => (
  <SkapaPill ref={ref} size="small" iconPosition="center" {...props} />
));

export default Pill;
